import { services } from '@/service';
import reporter from '@/lib/reporter';
import qs from 'qs';

export function initRouterController({ router, store }) {
  // 判断是否有无登录
  router.beforeEach((to, from, next) => {
    const { noAuth = false, continueRoute = false, documentTitle = '小包公 · 法律实证分析平台' } = to.meta || {};
    window.document.title = documentTitle;

    const isLogin = store.getters.isLogin;

    if (noAuth) {
      if (isLogin && !continueRoute) {
        if (to.name === 'wechatLogin' && to.query.redirect_name) {
          next({ name: to.query.redirect_name, query: qs.parse(decodeURIComponent(to.query.redirect_query)) });
        } else {
          next('/');
        }
      } else {
        next();
      }
    } else {
      isLogin
        ? next()
        : next({ name: 'wechatLogin', query: { redirect_name: to.name, redirect_query: qs.stringify(to.query) } });
    }
  });

  router.afterEach(() => {
    store.dispatch('clearCourseVersion');
  });

  const firstTime = Date.now();
  let preTime = firstTime;
  router.afterEach((to, from) => {
    const nowTime = Date.now();
    const duration = nowTime - preTime;
    preTime = nowTime;
    try {
      services.logger.routerLog({
        to: { path: to.path, query: to.query },
        from: from ? { path: from.path, query: from.query } : {},
        firstTime,
        nowTime,
        duration,
        token: window.localStorage.getItem('token')
      });
    } catch (err) {
      reporter.log({ message: err.message, code: '路由跳转log接口异常' });
    }
  });
}
